import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { constants } from '../../constants';
import { MyMDropDownList } from '../../ui-elements/MyMDropDownList';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink, MyMLink } from '../../ui-elements/MyMLink';
import BoxFileRequestMenu from "../../ui-parts/BoxFileRequestMenu";
import { FileMappingIcon } from '../../ui-parts/FileMappingIcon';
import { KeywordLabel } from '../../ui-parts/KeywordLabel';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { PagingDataGrid } from '../../ui-parts/PagingDataGrid';
import { GridTooltipCell } from '../../ui-parts/TooltipLabel';
import { utility } from '../../utility';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { FilterMenu } from '../../ui-parts/FilterMenu';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { Pager } from '../../ui-parts/Pager';
import { IconButton } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import Popover from '@mui/material/Popover';
import { SortIconMenu } from '../../ui-parts/SortIconMenu';

const SearchResultListViewSearchResultCard = (props) => {
  const {
    screenId,
    pageNumber,
    setPageNumber,
    searchResult,
    onSortByChange,
    onClickPreview,
    controlSettings,
    messageList,
    sortByDDL,
    keyword,
    selectedSortBy,
    setIsLoading,
    // 2024.5.8 MyMine Version1.5対応 Add Start
    isListLoading,
    searchValue,
    apliableFilterList,
    // 2024.5.8 MyMine Version1.5対応 Add End
    // 2024.9.16 MyMine Version2.0対応 Add Start
    apiRequest,
    metadataList,
    setApliableFilterList,
    checkedList,
    setCheckedList
    // 2024.9.16 MyMine Version2.0対応 Add End
    // 2026.2.25 タブレット表示時対応 Add Start
    , ellipsisNumberMobile ,
    ellipsisNumberPC
    // 2026.2.25 タブレット表示時対応 Add End
  } = props;
  // 2024.9.16 MyMine Version2.0対応 Add Start
  const isPc = useMediaQuery(mediaQuery.pc);
  const [isOpenFilterMenu, setIsOpenFilterMenu] = useState(false);
  const openFilterMenu = () => setIsOpenFilterMenu(true);
  const closeFilterMenu = () => setIsOpenFilterMenu(false);
  // 2024.9.16 MyMine Version2.0対応 Add End
  // 2026.2.25 タブレット表示時対応 Add Start
  const isMobile = useMediaQuery('(max-width:600px)');
  const ellipsisNumber = isMobile ? ellipsisNumberMobile : ellipsisNumberPC;
  // 2026.2.25 タブレット表示時対応 Add End

  // 2025.6.20 MyMine Version3.0対応 Add Start
  const [isHover, setIsHover] = useState(false)
  // 2025.6.20 MyMine Version3.0対応 Add End

  // 2024.9.16 MyMine Version2.0対応 Add Start
  const navigateNewsPage = (newsId, url, newsType) => {
    if (newsType === constants.NewsType.InternalNews) {
      // InternalNews
      window.open(`${process.env.PUBLIC_URL}/MyM102/MyM501/MyM502/${newsId}`, '_blank');
      return;
    } else {
      // GlobalSiteNews
      apiRequest.requestJson('api/news/external-link-transition?newsId=' + newsId, 'GET', null, null, null);
      window.open(url, '_blank');
    }
  }
  // 2024.9.16 MyMine Version2.0対応 Add End

  // 2024.5.8 MyMine Version1.5対応 Add Start
  const [columns] = useState([{
    field: 'FileName',
    headerName: controlSettings.LabelList.lblFileNameHeader,
    width: 350,
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    renderCell: (params) =>
      params.row.DataType === constants.DataType.Box ?
        <GridTooltipCell toolTipValue={params.row.NameDisp} width={params.colDef.computedWidth}>
          <MyMBlackLink component='a' className='text-truncate' sx={{ cursor: 'pointer' }} notUseLabel={true} onClick={(e) => { onClickPreview(e, params.row.DataId) }}>
            <Box className='d-inline-block pe-2'>
              < FileMappingIcon screenId={screenId} extension={params.row.Extension} width="35px" height="35px" />
            </Box>
            <KeywordLabel keyword={keyword} value={params.row.NameDisp} fontSize={styles.fontSize} />
          </MyMBlackLink>
        </GridTooltipCell>
        :
        <GridTooltipCell
          toolTipValue={params.row.DataType === constants.DataType.News ? params.row.Title : controlSettings.LabelList[`lblDocument_${params.row.DataId}`]}
          width={params.colDef.computedWidth}>
          <MyMBlackLink component='a' className='text-truncate' sx={{ cursor: 'pointer' }} notUseLabel={true}
            onClick={() => params.row.DataType === constants.DataType.News ?
              navigateNewsPage(params.row.DataId, params.row.Url, params.row.NewsType) :
              window.open(controlSettings.UrlList[`urlContents_${params.row.DataId}`], '_blank')}
          >
            <Box className='d-inline-block pe-2'>
              <MyMImage
                screenId={screenId}
                filePath={params.row.DataType === constants.DataType.News ? controlSettings.ImageList.imgNewsIcon : controlSettings.ImageList.imgContentsIcon}
                width="35px"
                height="35px"
              />
            </Box>
            <KeywordLabel
              keyword={keyword}
              value={params.row.DataType === constants.DataType.News ? params.row.Title : controlSettings.LabelList[`lblDocument_${params.row.DataId}`]}
              fontSize={styles.fontSize} />
          </MyMBlackLink>
        </GridTooltipCell>
    ,
    // 2024.9.16 MyMine Version2.0対応 Modify End
    sortable: false,
  },
  {
    field: 'Description',
    headerName: controlSettings.LabelList.lblDescriptionHeader,
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      return <GridTooltipCell
        toolTipValue={params.row.DataType !== constants.DataType.Contents ? params.row.Description : controlSettings.LabelList[`lblDescription_${params.row.DataId}`]}
        width={params.colDef.computedWidth}
      >{params.row.DataType !== constants.DataType.Contents ? params.row.Description : controlSettings.LabelList[`lblDescription_${params.row.DataId}`]}
      </GridTooltipCell>
      // 2024.9.16 MyMine Version2.0対応 Modify End
    },
  },
  {
    field: 'FileSize',
    headerName: controlSettings.LabelList.lblFileSizeHeader,
    width: 100,
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    valueGetter: (value, row) => row.FileSize != null ? `${utility.convertFileSize(row.FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}` : '-',
    // 2024.9.16 MyMine Version2.0対応 Modify End
    sortable: false,
    align: 'right'
  },
  {
    field: 'UploadDate',
    headerName: controlSettings.LabelList.lblUploadDateHeader,
    width: 170,
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    valueGetter: (value, row) => row.DataType !== constants.DataType.Contents ? utility.formatDateTime(row.UploadDate, 'd MMMM yyyy') : '-',
    // 2024.9.16 MyMine Version2.0対応 Modify End
    sortable: false
  },
  {
    field: 'OperationMenu',
    headerName: '',
    width: 240,
    renderCell: (params) =>
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      <Box sx={{ textAlign: 'center' }}>
        {
          params.row.DataType === constants.DataType.Box ?
            <BoxFileRequestMenu
              screenId={screenId}
              fileId={params.row.DataId}
              setIsLoading={setIsLoading}
              isFavorite={params.row.IsFavorite}
              callbackFavorite={callbackFavorite}
              canShareContents={true}
              listViewFlg={true}
            /> :
            <MyMLink
              onClick={() => params.row.DataType === constants.DataType.News ?
                navigateNewsPage(params.row.DataId, params.row.Url, params.row.NewsType) :
                window.open(controlSettings.UrlList[`urlContents_${params.row.DataId}`], '_blank')}
            >
              {params.row.DataType === constants.DataType.News ?
                controlSettings.LabelList.lnkGoToNews :
                controlSettings.LabelList.lnkGoToContent}
            </MyMLink>
        }
      </Box>
    // 2024.9.16 MyMine Version2.0対応 Modify End
    ,
    sortable: false,
    resizable: false,
  },
  ]);
  // 2024.5.8 MyMine Version1.5対応 Add End
  // 2024.9.16 MyMine Version2.0対応 Add Start

  // 2024.9.16 MyMine Version2.0対応 Add End
  const theme = useTheme();

  /**
   * お気に入りコールバック処理
   * @param {number} favoriteFileId お気に入りファイルID
   */
  const callbackFavorite = (favoriteFileId) => {
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    const favoriteFile = searchResult.ItemList.find(x => x.DataId === favoriteFileId);
    // 2024.9.16 MyMine Version2.0対応 Modify End    
    // お気に入り情報を更新
    favoriteFile.IsFavorite = !favoriteFile.IsFavorite;
  }

  const styles = {
    fontSize: '0.95rem',
    mobileFontSize: '0.76rem'
  };

  const [popoverState, setPopoverState] = useState({});

  const handleClick = (event, rowDataId) => {
    setPopoverState({
      ...popoverState,
      [rowDataId]: {
        open: true,
        anchorEl: event.currentTarget
      }
    });
  };

  const handleClose = (rowDataId) => {
    setPopoverState({
      ...popoverState,
      [rowDataId]: {
        open: false,
        anchorEl: null
      }
    });
  };
  // ビュー切替用ドロップダウン

  return (
    <OutlinedCustomCard>
      {isPc
        ? <CardHeader
          sx={{ display: 'flex', background: theme.palette.background.secondary, height: '65px' }}
          action={
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <Box>
                <MyMDropDownList
                  autoWidth
                  value={selectedSortBy}
                  onChange={(e) => { onSortByChange(e) }}
                  options={sortByDDL.map((data) => {
                    return {
                      value: data.value,
                      text: data.text
                    }
                  })}
                  sx={{
                    color: 'white', width: isPc ? '300px' : 'calc(100% - 20px)'
                  }}
                />
              </Box>
            </Box>
          }
          //2025.7.7 MyMine Version3.0対応 Add Start
          title={
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                height: '30px',
              }}
            >
              <Box sx={{
                padding: '10px',
                backgroundColor: '#2b2b2b',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }} >
                <Box sx={{ paddingRight: '10px' }} className='d-flex align-items-center justify-content-center'>
                  <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgListViewIcon} width='25px' />
                </Box>
                <Box>
                  <MyMLabel color='#fff' fontSize='17px'>{controlSettings.LabelList.lblListView}</MyMLabel>
                </Box>
              </Box>
              <NavigateLink
                to='/MyM102/MyM402'
                navigateState={{
                  state: {
                    searchValue: searchValue,
                    filterList: apliableFilterList,
                    selectedId: selectedSortBy
                  }
                }}
                underline='none'
              >
                <Box sx={{
                  paddingLeft: '13px',
                  display: 'flex',
                  alignItems: 'center',
                  opacity: '0.5'
                }}
                  onMouseEnter={() => setIsHover(true)}
                  onMouseLeave={() => setIsHover(false)}
                >
                  <Box
                    sx={{ paddingRight: '10px' }}
                    className='d-flex align-items-center justify-content-center'
                  >
                    <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgThumbnailViewIcon} width='25px' />
                  </Box>
                  <Box
                    sx={{
                      transition: 'border-bottom 0.2s ease',
                      borderBottom: isHover && '1.5px solid #000 ',
                    }}
                  >
                    <MyMLabel color='#000' fontSize='17px' sx={{ whiteSpace: 'nowrap' }}>
                      {controlSettings.LabelList.lblThumbnailView}
                    </MyMLabel>
                  </Box>
                </Box>
              </NavigateLink>
            </Box>
          }
        //2025.6.20 MyMine Version3.0対応 Add End
        />
        : <Box sx={{ display: 'flex', flexWrap: 'wrap', background: theme.palette.background.secondary, justifyContent: 'space-between' }}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              margin: '10px 0px 10px 10px'
            }}
          >
            <Box
              sx={{
                padding: '10px',
                backgroundColor: '#2b2b2b',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }}
            >
              <Box className='d-flex align-items-center justify-content-center'>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgListViewIcon} width='25px' />
              </Box>
            </Box>

            <NavigateLink
              to='/MyM102/MyM402'
              navigateState={{
                state: {
                  searchValue: searchValue,
                  filterList: apliableFilterList,
                  selectedId: selectedSortBy
                }
              }}
              underline='none'
            >
              <Box sx={{
                paddingLeft: '13px',
                display: 'flex',
                alignItems: 'center',
                opacity: '0.5'
              }}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              >
                <Box
                  sx={{ paddingRight: '5px' }}
                  className='d-flex align-items-center justify-content-end'
                >
                  <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgThumbnailViewIcon} width='25px' />
                </Box>
              </Box>
            </NavigateLink>
          </Box>

          <Box sx={{ margin: '10px 20px 10px 10px', marginLeft: 'auto' }}>
            <SortIconMenu
              autoWidth
              value={selectedSortBy}
              onChange={(e) => onSortByChange(e)}
              options={sortByDDL.map((data) => {
                return {
                  value: data.value,
                  text: data.text
                }
              })}
            />
            <FilterMenu
              isOpenFilterMenu={isOpenFilterMenu}
              openFilterMenu={openFilterMenu}
              closeFilterMenu={closeFilterMenu}
              content={metadataList}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </Box>
        </Box>
      }
      <CardContent sx={{ height: 585, paddingTop: '5px', paddingLeft: isPc ? '40px' : '20px', paddingRight: isPc ? '40px' : '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
          <MyMLabel>
            {controlSettings.LabelList.lblKeywordTitle}
            <MyMLabel component='span' sx={{ color: 'red' }}>
              {keyword}
            </MyMLabel>
          </MyMLabel>
        </Box>
        {searchResult.ItemList.length === 0
          ? <MyMLabel className='d-flex justify-content-center'>{messageList.MyM_MSG_I_0023}</MyMLabel>
          :
          // 2024.5.8 MyMine Version1.5対応 Modify Start
          <>
            <Box sx={{
              height: isPc ? '85%' : '85%',
              '.MuiDataGrid-root': { border: 'none', marginBottom: '23px' },
            }}>
              {isPc ?
                <>
                  <PagingDataGrid
                    // DataGrid用
                    onColumnWidthChange={(column) => columns.filter(x => x.field === column.colDef.field)[0].width = column.width}
                    columns={columns}
                    dataList={searchResult.ItemList.map((row) => {
                      return {
                        ...row,
                        // 2024.9.16 MyMine Version2.0対応 Modify Start
                        id: row.DataId,
                        // 2024.9.16 MyMine Version2.0対応 Modify End
                      }
                    })}
                    uniquyKey={(row) => row.id}
                    isLoading={isListLoading}
                    rowHeight={58}
                    sx={{
                      marginBottom: '5px',
                      '.MuiDataGrid-columnHeaders > div[role=row]': {
                        backgroundColor: 'white !important',
                        color: 'black !important'
                      },
                      '.MuiDataGrid-columnSeparator': {
                        visibility: 'visible !important'
                      },
                      '.MuiDataGrid-cell': {
                        borderTop: 'none !important'
                      },
                    }}
                    // Pager用
                    resultListItem={searchResult}
                    handlePageChange={(pageNum) => setPageNumber(pageNum)}
                    labelList={controlSettings.LabelList}
                    messageList={messageList}
                    pageNumber={pageNumber}
                  />
                </>
                :
                <>
                  <>
                    <TableContainer sx={{ height: '100%' }}>
                      <Table>
                        <TableBody sx={{
                          'tr > td': { paddingTop: 1, },
                          'tr:nth-of-type(2n) > td': { paddingBottom: 1 },
                          'tr:nth-of-type(2n-1) > td': { paddingBottom: 1 },
                        }}>
                          {searchResult.ItemList.map((row) => (
                            <React.Fragment key={row.DataId}>
                              <TableRow>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {row.DataType === constants.DataType.Box ?
                                      <>
                                        <MyMBlackLink
                                          component="a"
                                          className="text-truncate"
                                          sx={{ cursor: 'pointer' }}
                                          notUseLabel={true}
                                          onClick={(e) => { onClickPreview(e, row.DataId); }}
                                        >
                                          <Box className="d-inline-block pe-2">
                                            <FileMappingIcon screenId={screenId} extension={row.Extension} width="45px" height="45px" />
                                          </Box>
                                        </MyMBlackLink>
                                        <Box sx={{ display: 'inline-block', verticalAlign: 'top' }}>
                                          <MyMBlackLink
                                            component="a"
                                            className="text-truncate"
                                            sx={{ cursor: 'pointer' }}
                                            notUseLabel={true}
                                            onClick={(e) => { onClickPreview(e, row.DataId); }}
                                          >
                                            {/* 2026.2.25 タブレット表示時対応 Modify Start */}
                                            <KeywordLabel keyword={keyword} value={utility.convertEllipsisFormat(row.NameDisp, ellipsisNumber)} fontSize={styles.fontSize} />
                                            {/* 2026.2.25 タブレット表示時対応 Modify End */}
                                          </MyMBlackLink>
                                          <Box sx={{ display: 'flex', marginTop: 0.5 }}>
                                            <Box sx={{ marginRight: 1, fontSize: styles.mobileFontSize }}>
                                              {row.FileSize != null
                                                ? `${utility.convertFileSize(row.FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}`
                                                : '-'}
                                            </Box>
                                            <Box sx={{ fontSize: styles.mobileFontSize }}>
                                              {row.DataType !== constants.DataType.Contents ? utility.formatDateTime(row.UploadDate, 'd MMMM yyyy') : '-'}
                                            </Box>
                                          </Box>
                                        </Box>

                                      </>
                                      :
                                      <>

                                        <Box className="d-inline-block pe-2">
                                          <MyMImage
                                            screenId={screenId}
                                            filePath={row.DataType === constants.DataType.News ? controlSettings.ImageList.imgNewsIcon : controlSettings.ImageList.imgContentsIcon}
                                            width="45px"
                                            height="50px"
                                          />
                                        </Box>
                                        <Box sx={{ display: 'inline-block', verticalAlign: 'top' }}>
                                          <MyMBlackLink component='a' className='text-truncate' sx={{ cursor: 'pointer' }} notUseLabel={true}
                                            onClick={() => row.DataType === constants.DataType.News ?
                                              navigateNewsPage(row.DataId, row.Url, row.NewsType) :
                                              window.open(controlSettings.UrlList[`urlContents_${row.DataId}`], '_blank')}
                                          >
                                            {/* 2026.2.25 タブレット表示時対応 Modify Start */}
                                            <KeywordLabel
                                              keyword={keyword}
                                              value={row.DataType === constants.DataType.News ? utility.convertEllipsisFormat(row.Title, ellipsisNumber) : utility.convertEllipsisFormat(controlSettings.LabelList[`lblDocument_${row.DataId}`], ellipsisNumber)}
                                              fontSize={styles.fontSize}
                                            />
                                            {/* 2026.2.25 タブレット表示時対応 Modify End */}
                                          </MyMBlackLink>
                                          <Box sx={{ display: 'flex', marginTop: 0.5 }}>
                                            <Box sx={{ marginTop: 1, fontSize: styles.mobileFontSize }}>
                                              {row.FileSize != null
                                                ? `${utility.convertFileSize(row.FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}`
                                                : '-'}
                                            </Box>
                                            <Box sx={{ fontSize: styles.mobileFontSize }}>
                                              {row.DataType !== constants.DataType.Contents ? utility.formatDateTime(row.UploadDate, 'd MMMM yyyy') : '-'}
                                            </Box>
                                          </Box>
                                        </Box>

                                      </>
                                    }
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
                                      <IconButton onClick={(e) => handleClick(e, row.DataId)}>
                                        <PendingIcon />
                                      </IconButton>
                                    </Box>
                                    <Popover
                                      open={popoverState[row.DataId]?.open || false}
                                      anchorEl={popoverState[row.DataId]?.anchorEl || null}
                                      onClose={() => handleClose(row.DataId)}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                      }}
                                    >
                                      <Box sx={{ padding: '16px' }}>
                                        <Box sx={{ textAlign: 'center' }}>

                                          {row.DataType === constants.DataType.Box ? (
                                            <BoxFileRequestMenu
                                              screenId={screenId}
                                              fileId={row.DataId}
                                              setIsLoading={setIsLoading}
                                              isFavorite={row.IsFavorite}
                                              callbackFavorite={callbackFavorite}
                                              canShareContents={true}
                                              listViewFlg={true}
                                            />
                                          ) : (
                                            <MyMLink
                                              onClick={() => row.DataType === constants.DataType.News
                                                ? navigateNewsPage(row.DataId, row.Url, row.NewsType)
                                                : window.open(controlSettings.UrlList[`urlContents_${row.DataId}`], '_blank')}
                                            >
                                              {row.DataType === constants.DataType.News
                                                ? controlSettings.LabelList.lnkGoToNews
                                                : controlSettings.LabelList.lnkGoToContent}
                                            </MyMLink>
                                          )}

                                        </Box>
                                      </Box>
                                    </Popover>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                  <Pager
                    resultListItem={searchResult}
                    handleChangePage={(pageNum) => setPageNumber(pageNum)}
                    labelList={controlSettings.LabelList}
                    pageNumber={pageNumber}
                  />
                </>
              }

            </Box>
          </>
          // 2024.5.8 MyMine Version1.5対応 Modify End
        }
      </CardContent>
    </OutlinedCustomCard >
  );
}
export default SearchResultListViewSearchResultCard;